import { render, staticRenderFns } from "./SalaryReceiptPercepts.vue?vue&type=template&id=0751c1d8&scoped=true&"
import script from "./SalaryReceiptPercepts.vue?vue&type=script&lang=js&"
export * from "./SalaryReceiptPercepts.vue?vue&type=script&lang=js&"
import style0 from "./SalaryReceiptPercepts.vue?vue&type=style&index=0&id=0751c1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0751c1d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0751c1d8')) {
      api.createRecord('0751c1d8', component.options)
    } else {
      api.reload('0751c1d8', component.options)
    }
    module.hot.accept("./SalaryReceiptPercepts.vue?vue&type=template&id=0751c1d8&scoped=true&", function () {
      api.rerender('0751c1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/SalaryReceiptPercepts.vue"
export default component.exports